module.exports = __webpack_public_path__ + "img/stockQuery.4b6fb8a4.png";